import React from 'react';
import { motion } from 'framer-motion';
import { BackgroundBeams } from './BackgroundBeams';
import './Services.css';
import {
  FaBrain,
  FaLaptopCode,
  FaMobileAlt,
  FaBriefcase,
  FaSyncAlt,
  FaCloud,
  FaShieldAlt,
  FaServer,
  FaArrowRight,
  FaPaintBrush
} from 'react-icons/fa';

const primaryServices = [
  {
    icon: <FaBrain />,
    title: 'AI Solutions',
    description: 'Unlock intelligent automation and data-driven insights.'
  },
  {
    icon: <FaLaptopCode />,
    title: 'Web Development',
    description: 'Build powerful, scalable, and secure web applications.'
  },
  {
    icon: <FaMobileAlt />,
    title: 'Mobile Apps',
    description: 'Engage your users with intuitive iOS and Android apps.'
  },
  {
    icon: <FaBriefcase />,
    title: 'Business Solutions',
    description: 'Custom software to solve your unique business challenges.'
  },
  {
    icon: <FaPaintBrush />,
    title: 'Branding',
    description: 'Comprehensive branding solutions to define, design, and deliver a compelling brand experience.'
  },
  {
    icon: <FaShieldAlt />,
    title: 'Cyber - Solutions',
    description: 'Protecting computer systems, devices, data and more from digital attacks.'
  }
];

const additionalExpertise = [
  {
    icon: <FaSyncAlt />,
    title: 'Automation',
    description: 'Streamline workflows with our process automation solutions.'
  },
  {
    icon: <FaCloud />,
    title: 'Cloud Services',
    description: 'Deploy and manage scalable cloud infrastructure.'
  },
  {
    icon: <FaShieldAlt />,
    title: 'Cybersecurity',
    description: 'Protect your assets with advanced security measures.'
  },
  {
    icon: <FaServer />,
    title: 'DevOps',
    description: 'Accelerate delivery with CI/CD and deployment automation.'
  }
];

const Services = () => {
  return (
    <section id="services">
      <BackgroundBeams />
      <div className="container">
        <div className="section-header">
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h2 className="section-title">
              Our <span>Services</span>
            </h2>
            <p className="section-subtitle">
              We provide comprehensive digital solutions to transform your business and accelerate growth through innovative technology.
            </p>
          </motion.div>
        </div>

        {/* Tablet Frame */}
        <div className="tablet-container">
          <div className="tablet-frame">
            {/* Dynamic Island */}
            <div className="tablet-island"></div>

            {/* Tablet Screen */}
            <div className="tablet-screen">

              {/* Mobile/Tablet Scroll Hint */}
              <div className="scroll-hint">
                <span className="scroll-arrow"></span>
              </div>
              
              <BackgroundBeams />

              {/* Primary Services */}
              <div className="primary-services-grid">
                {primaryServices.map((service, index) => (
                  <div className="primary-service-card" key={index}>
                    <div className="card-icon">{service.icon}</div>
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <a href="/services" className="learn-more-link">
                      Learn More <FaArrowRight />
                    </a>
                  </div>
                ))}
              </div>

              {/* Additional Expertise */}
              <div className="additional-expertise-section">
                <h3 className="expertise-title">Additional Expertise</h3>
                <div className="expertise-grid">
                  {additionalExpertise.map((item, index) => (
                    <div className="expertise-item" key={index}>
                      <div className="expertise-icon">{item.icon}</div>
                      <div className="expertise-text">
                        <h4>{item.title}</h4>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* CTA */}
              <div className="services-cta">
                <h2>Ready to Transform Your Business?</h2>
                <p>Let's discuss how our solutions can accelerate your digital transformation journey.</p>
                <a href="#contact" className="cta-button">Get Started Today</a>
              </div>



            </div>

            {/* Bottom Notch */}
            <div className="tablet-bottom-notch"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
